import * as React from 'react';
// media query
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import MobileStepper from '@mui/material/MobileStepper';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import { enableQuestion, getSampleQuiz, updateQuiz } from './SampleQuizRequest';
import { blue, green, orange, red } from '@mui/material/colors';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
// const steps = [
//   {
//     label: 'Question #1',
//     description: `For each ad campaign that you create, you can control how much
//               you're willing to spend on clicks and conversions, which networks
//               and geographical locations you want your ads to show on, and more.`,
//   },
//   {
//     label: 'Create an ad group',
//     description:
//       'An ad group contains one or more ads which target a shared set of keywords.',
//   },
//   {
//     label: 'Create an ad',
//     description: `Try out different ad text to see what brings in the most customers,
//               and learn how to enhance your ads using features like ad extensions.
//               If you run into any problems with your ads, find out how to tell if
//               they're running and how to resolve approval issues.`,
//   },
// ];

export const SampleQuiz = () =>{
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.down('sm'));
    const [activeStep, setActiveStep] = React.useState(0);
    const [steps,setSteps] = React.useState([])
    const prevCountRef = React.useRef(0)
    React.useEffect(() => {
        prevCountRef.current = activeStep;
      }, [activeStep])
    // const maxSteps = steps.length;
    React.useEffect(()=>{
        _init();
    },[])
    const _init = async () => {
        const res = await getSampleQuiz()
        console.log(res.data)
        let s = [] ;
        res.data.data.forEach(el=>{
            s.push({
                id:el.id,
                label:`Question #${el.sort}`,
                description:el.question,
                difficulty:el.difficulty,
                answer:el.answer,
                point:el.point,
            })
            if(el.enabled){
                setActiveStep(el.sort-1)
                setStarted(el.started?true:false)
            }
        })
        setSteps(s)
    }
    const handleNext = async () => {
        let id = steps[activeStep+1].id;
        // let prev_id = steps[prevCountRef.current].id;
        let prev_id = steps[activeStep].id;
        const res = await enableQuestion({id:id,prev_id:prev_id,started:started});
        setActiveStep((prevActiveStep) => prevActiveStep + 1);

    };

    const handleBack = async () => {
        let id = steps[activeStep>0?activeStep-1:0].id;

        // let prev_id = steps[prevCountRef.current].id;
        let prev_id = steps[activeStep+1 === steps.length?steps.length-1:activeStep+1].id;
        // console.log(activeStep+1 === steps.length?steps.length:activeStep+1)
        const res = await enableQuestion({id:id,prev_id:prev_id,started:started});
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };
    const [started,setStarted] = React.useState(false)
    React.useEffect(()=>{
        // if(started){
        //     _handleStart();
        // }
        _handleStart();
    },[started])
    const _handleStart = async () => {
        if(steps.length>0 ){
            if(steps[activeStep].id){
                const res = await updateQuiz({id:steps[activeStep].id,started:started})
            }
        }
    }
    return (
    <Box sx={{display:'flex',justifyContent:'center',pt:5}}>
    {
        steps.length>0
        ?
        <Box sx={{ maxWidth: '70%', flexGrow: 1 }}>
            <Typography align='center' variant={matches?'h6':'h4'} sx={{color:steps[activeStep].difficulty==='Easy'?green[800]:steps[activeStep].difficulty==='Intermediate'?orange[800]:red[800]}}>{steps[activeStep].difficulty} ({steps[activeStep].point} {steps[activeStep].point>1?'points':'point'})</Typography>

            <Paper
            square
            elevation={0}
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent:'space-between',
                height: 50,
                pl: 2,
                bgcolor: 'background.default',
                // bgcolor: '#000',
                width:'100%'
            }}
            >
            <Box>
                <Typography variant={matches?'h5':'h2'} sx={{color:blue[800]}}>{steps[activeStep].label}</Typography>
            </Box>
            <FormControlLabel control={<Switch checked={started} onChange={()=>setStarted(prev=>!prev)} />} label="Start" />
            </Paper>
            <Box sx={{ height: '60dvh', width: '100%', p: 2 ,mt:matches?0:4,display:'flex',justifyContent:'center',alignItems:'center'}}>
                <Typography sx={{textAlign:'center',whiteSpace:'break-space', fontWeight:100,fontSize:steps[activeStep].description.length>=740?'1.8rem':steps[activeStep].description.length>=230 ?'2.5rem':steps[activeStep].description.length>=85 ?'3rem':'5rem'}} >{steps[activeStep].description}</Typography>
            </Box>
            <MobileStepper
                variant="text"
                steps={steps.length}
                position="static"
                activeStep={activeStep}
                nextButton={
                    <Button
                    size="small"
                    onClick={handleNext}
                    disabled={activeStep === steps.length - 1}
                    >
                    Next
                    {theme.direction === 'rtl' ? (
                        <KeyboardArrowLeft />
                    ) : (
                        <KeyboardArrowRight />
                    )}
                    </Button>
                }
                backButton={
                    <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
                    {theme.direction === 'rtl' ? (
                        <KeyboardArrowRight />
                    ) : (
                        <KeyboardArrowLeft />
                    )}
                    Back
                    </Button>
                }
            />
        </Box>
        :
        null
    }
    
    </Box>
    );
}